import Vuex from "vuex";
import Vue from "vue";
import {UPDATE_HALL} from "./storeMutator";

Vue.use(Vuex);

const Store = new Vuex.Store({
  state: {
    SessionData: {},
  },

  getters: {
    getSessionData(state) {
      return state.SessionData;
    },
  },

  mutations: {
    updateMember(state, memberToUpdate) {
      state.SessionData.member = memberToUpdate;
    },

    updateSessionData(state, sessionData) {
      state.SessionData = sessionData;
    },

    updateCourse(state, courseToUpdate) {
      if (state.SessionData.club.courses === undefined || state.SessionData.club.courses.lenght === 0) return;

      var coursePos = state.SessionData.club.courses.map((course) => course.CourseId).indexOf(courseToUpdate.CourseId);
      state.SessionData.club.courses.splice(coursePos, 1, courseToUpdate);
    },

    updateHall(state, hallToUpdate) {
      if (state.SessionData.club.halls === undefined || state.SessionData.club.halls.lenght === 0) return;

      var hallPos = state.SessionData.club.halls.map((hall) => hall.Id).indexOf(hallToUpdate.Id);
      state.SessionData.club.halls.splice(hallPos, 1, hallToUpdate);
    },

    updateHallMeeting(state, {hallToWorkWith, meetingToUpdate}) {
      var hallObjKeys = Object.keys(hallToWorkWith);

      if (!hallObjKeys.includes("meetings")) return;
      if (hallToWorkWith === undefined || hallToWorkWith.meetings == undefined || hallToWorkWith.meetings.lenght === 0) return;

      var meetingPos = hallToWorkWith.meetings.map((meeting) => meeting.To).indexOf(meetingToUpdate.To);
      hallToWorkWith.meetings.splice(meetingPos, 1, meetingToUpdate);

      Store.commit(UPDATE_HALL, hallToWorkWith);
    },

    resetStore(state) {
      state = {
        SessionData: {},
      };
    },
  },
});

export default Store;
